import { render, staticRenderFns } from "./HelpCenterZlj.vue?vue&type=template&id=f68dc89c&scoped=true"
import script from "./HelpCenterZlj.vue?vue&type=script&lang=js"
export * from "./HelpCenterZlj.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterZlj.vue?vue&type=style&index=0&id=f68dc89c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68dc89c",
  null
  
)

export default component.exports